import React, { useState } from "react";
import styles from "./Content.module.css";

const Content = ({ content }) => {
  const [readMore, setReadMore] = useState(0);

  const Toggle = () => {
    setReadMore(!readMore);
  };

  return (
    <div
      className={`bg-white p-4 mt-5 rounded-lg shadow-lg text-gray-500 leading-6 `}
    >
      <div
        className={` transform-gpu  transition-all`}
        dangerouslySetInnerHTML={{ __html: content }}
      ></div>
      {/* <button
        onClick={Toggle}
        className="px-2 py-1 mt-2 text-xs text-white bg-gray-600 rounded"
      >
        {readMore ? "Devamını Gizle" : "Devamını Oku..."}
      </button> */}
    </div>
  );
};

export default Content;
